import React from 'react';
import { leadStatusTone } from '../utils/leadStatusColors';

type LeadStatusBadgeProps = {
  status: string | null | undefined;
  className?: string;
};

/** Einzeilige Status-Pille — einzige farbige Fläche in einer Listenzeile. */
export function LeadStatusBadge({ status, className = '' }: LeadStatusBadgeProps) {
  const text = String(status ?? '').trim();
  if (!text) return <span className={`text-xs text-app-text-subtle ${className}`}>—</span>;

  const tone = leadStatusTone(text);
  return (
    <span
      title={text}
      className={`inline-flex max-w-full items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap ring-1 ring-inset ${tone.pill} ${className}`}
    >
      <span className={`h-1.5 w-1.5 shrink-0 rounded-full ${tone.dot}`} aria-hidden />
      <span className="truncate">{text}</span>
    </span>
  );
}
